// export const SERVER_URL = 'https://gigs.wizer.pro/wizerapi'
// export const SERVER_URL = 'https://qa.wizer.pro/wizerapi'
// export const SERVER_URL = 'https://qa.wizer.pro/wizerapi'
//export const SERVER_URL = 'https://wizer-api-qa-dycfchahbgg8hdbk.uaenorth-01.azurewebsites.net'
export const SERVER_URL = 'https://wizer-api-prod-g8fucrf9b7a9drgj.uaenorth-01.azurewebsites.net'
//export const WIZER_CDN = 'https://qa-cdn.wizer.pro'
export const WIZER_CDN = 'https://prod-cdn.wizer.pro'
//export const REFERRAL_SERVER_URL = 'https://qa-cdn.wizer.pro'
export const REFERRAL_SERVER_URL = 'https://prod-cdn.wizer.pro'
export const MAX_BANNER = 5;
export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes
export const phoneLengths = {
    "+93": 9,    // Afghanistan
    "+355": 9,   // Albania
    "+213": 9,   // Algeria
    "+1": 10,    // United States and Canada
    "+376": 6,   // Andorra
    "+244": 9,   // Angola
    "+54": 10,   // Argentina
    "+374": 8,   // Armenia
    "+61": 9,    // Australia
    "+43": 10,   // Austria
    "+994": 9,   // Azerbaijan
    "+973": 8,   // Bahrain
    "+880": 10,  // Bangladesh
    "+375": 9,   // Belarus
    "+32": 9,    // Belgium
    "+501": 7,   // Belize
    "+229": 8,   // Benin
    "+975": 8,   // Bhutan
    "+591": 8,   // Bolivia
    "+387": 8,   // Bosnia and Herzegovina
    "+267": 7,   // Botswana
    "+55": 11,   // Brazil
    "+673": 7,   // Brunei
    "+359": 9,   // Bulgaria
    "+226": 8,   // Burkina Faso
    "+257": 8,   // Burundi
    "+855": 9,   // Cambodia
    "+237": 9,   // Cameroon
    "+1": 10,    // Canada
    "+238": 7,   // Cape Verde
    "+236": 8,   // Central African Republic
    "+235": 8,   // Chad
    "+56": 9,    // Chile
    "+86": 11,   // China
    "+57": 10,   // Colombia
    "+269": 7,   // Comoros
    "+242": 9,   // Congo
    "+243": 9,   // Congo, Democratic Republic
    "+682": 5,   // Cook Islands
    "+506": 8,   // Costa Rica
    "+225": 8,   // Côte d'Ivoire
    "+385": 9,   // Croatia
    "+53": 8,    // Cuba
    "+357": 8,   // Cyprus
    "+420": 9,   // Czech Republic
    "+45": 8,    // Denmark
    "+253": 6,   // Djibouti
    "+1": 7,     // Dominica
    "+1": 10,    // Dominican Republic
    "+593": 9,   // Ecuador
    "+20": 10,   // Egypt
    "+503": 8,   // El Salvador
    "+240": 9,   // Equatorial Guinea
    "+291": 7,   // Eritrea
    "+372": 7,   // Estonia
    "+268": 8,   // Eswatini
    "+251": 9,   // Ethiopia
    "+679": 7,   // Fiji
    "+358": 10,  // Finland
    "+33": 9,    // France
    "+594": 9,   // French Guiana
    "+689": 6,   // French Polynesia
    "+241": 7,   // Gabon
    "+220": 7,   // Gambia
    "+995": 9,   // Georgia
    "+49": 11,   // Germany
    "+233": 9,   // Ghana
    "+30": 10,   // Greece
    "+299": 6,   // Greenland
    "+502": 8,   // Guatemala
    "+224": 9,   // Guinea
    "+245": 9,   // Guinea-Bissau
    "+592": 7,   // Guyana
    "+509": 8,   // Haiti
    "+504": 8,   // Honduras
    "+852": 8,   // Hong Kong
    "+36": 9,    // Hungary
    "+354": 7,   // Iceland
    "+91": 10,   // India
    "+62": 11,   // Indonesia
    "+98": 10,   // Iran
    "+964": 10,  // Iraq
    "+353": 9,   // Ireland
    "+972": 9,   // Israel
    "+39": 10,   // Italy
    "+1": 7,     // Jamaica
    "+81": 10,   // Japan
    "+962": 9,   // Jordan
    "+7": 10,    // Kazakhstan
    "+254": 10,  // Kenya
    "+686": 8,   // Kiribati
    "+965": 8,   // Kuwait
    "+996": 9,   // Kyrgyzstan
    "+856": 10,  // Laos
    "+371": 8,   // Latvia
    "+961": 8,   // Lebanon
    "+266": 8,   // Lesotho
    "+231": 7,   // Liberia
    "+218": 9,   // Libya
    "+423": 7,   // Liechtenstein
    "+370": 8,   // Lithuania
    "+352": 9,   // Luxembourg
    "+853": 8,   // Macao
    "+389": 8,   // North Macedonia
    "+261": 9,   // Madagascar
    "+265": 9,   // Malawi
    "+60": 9,    // Malaysia
    "+960": 7,   // Maldives
    "+223": 8,   // Mali
    "+356": 8,   // Malta
    "+692": 7,   // Marshall Islands
    "+596": 9,   // Martinique
    "+222": 9,   // Mauritania
    "+230": 8,   // Mauritius
    "+52": 10,   // Mexico
    "+691": 7,   // Micronesia
    "+373": 8,   // Moldova
    "+377": 8,   // Monaco
    "+976": 8,   // Mongolia
    "+382": 8,   // Montenegro
    "+212": 9,   // Morocco
    "+258": 9,   // Mozambique
    "+95": 9,    // Myanmar (Burma)
    "+264": 9,   // Namibia
    "+674": 7,   // Nauru
    "+977": 10,  // Nepal
    "+31": 9,    // Netherlands
    "+64": 9,    // New Zealand
    "+505": 8,   // Nicaragua
    "+227": 8,   // Niger
    "+234": 10,  // Nigeria
    "+683": 4,   // Niue
    "+850": 10,  // North Korea
    "+47": 8,    // Norway
    "+968": 8,   // Oman
    "+92": 10,   // Pakistan
    "+680": 7,   // Palau
    "+507": 8,   // Panama
    "+675": 9,   // Papua New Guinea
    "+595": 9,   // Paraguay
    "+51": 9,    // Peru
    "+63": 10,   // Philippines
    "+48": 9,    // Poland
    "+351": 9,   // Portugal
    "+974": 8,   // Qatar
    "+242": 9,   // Republic of the Congo
    "+40": 10,   // Romania
    "+7": 10,    // Russia
    "+250": 9,   // Rwanda
    "+590": 9,   // Saint Barthelemy
    "+290": 4,   // Saint Helena
    "+1": 10,    // Saint Kitts and Nevis
    "+1": 10,    // Saint Lucia
    "+590": 9,   // Saint Martin
    "+508": 6,   // Saint Pierre and Miquelon
    "+1": 10,    // Saint Vincent and the Grenadines
    "+685": 7,   // Samoa
    "+378": 9,   // San Marino
    "+239": 8,   // Sao Tome and Principe
    "+966": 9,   // Saudi Arabia
    "+221": 9,   // Senegal
    "+381": 9,   // Serbia
    "+248": 7,   // Seychelles
    "+232": 8,   // Sierra Leone
    "+65": 8,    // Singapore
    "+421": 9,   // Slovakia
    "+386": 9,   // Slovenia
    "+677": 7,   // Solomon Islands
    "+252": 8,   // Somalia
    "+27": 10,   // South Africa
    "+82": 10,   // South Korea
    "+211": 9,   // South Sudan
    "+34": 9,    // Spain
    "+94": 9,    // Sri Lanka
    "+249": 9,   // Sudan
    "+597": 7,   // Suriname
    "+47": 8,    // Svalbard and Jan Mayen
    "+268": 8,   // Swaziland
    "+46": 7,    // Sweden
    "+41": 9,    // Switzerland
    "+963": 9,   // Syria
    "+886": 9,   // Taiwan
    "+992": 9,   // Tajikistan
    "+255": 9,   // Tanzania
    "+66": 9,    // Thailand
    "+228": 8,   // Togo
    "+690": 4,   // Tokelau
    "+676": 7,   // Tonga
    "+216": 8,   // Tunisia
    "+90": 10,   // Turkey
    "+993": 8,   // Turkmenistan
    "+688": 5,   // Tuvalu
    "+256": 9,   // Uganda
    "+380": 9,   // Ukraine
    "+971": 9,   // United Arab Emirates
    "+44": 10,   // United Kingdom
    "+1": 10,    // United States
    "+598": 9,   // Uruguay
    "+998": 9,   // Uzbekistan
    "+678": 7,   // Vanuatu
    "+379": 8,   // Vatican City
    "+58": 10,   // Venezuela
    "+84": 9,    // Vietnam
    "+681": 6,   // Wallis and Futuna
    "+967": 9,   // Yemen
    "+260": 9,   // Zambia
    "+263": 9    // Zimbabwe
}
